// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1eaq31baGEsVVI {\n  height: 20px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 70%;\n  margin: 0 auto;\n}\n._1eaq31baGEsVVI::before {\n  content: '';\n  display: block;\n  width: 100%;\n}\n._3MIIXZ-vsbf6TL::before {\n  border-top: 2px solid #C1C7D0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCard": "_1eaq31baGEsVVI",
	"singleHorizontalLine": "_3MIIXZ-vsbf6TL"
};
export default ___CSS_LOADER_EXPORT___;
